export const commonContainerStyles = (FOUNDATIONS, FONT) => ({
    position: 'fixed',
    display: 'flex',
    justify_content: 'center',
    align_items: 'center',
    cursor: 'pointer',
    padding: `${FOUNDATIONS.spacing_125} ${FOUNDATIONS.spacing_200}`,
    bottom: FOUNDATIONS.spacing_300,
    right: FOUNDATIONS.spacing_00,
    border_radius: `${FOUNDATIONS.radius_150} ${FOUNDATIONS.radius_00} ${FOUNDATIONS.radius_00} ${FOUNDATIONS.radius_150}`,
    width: FOUNDATIONS.size_475,
    box_shadow: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_75} ${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spread_negative_50} ${FOUNDATIONS.color_effect_shadow_drop_100}`,
    background: FOUNDATIONS.color_comp_actions_tabfab_bg,
});
export const commonIconStyles = (FOUNDATIONS, FONT) => ({
    color: FOUNDATIONS.color_comp_actions_tabfab_icon,
    height: FOUNDATIONS.size_300,
    width: FOUNDATIONS.size_300,
});
export const commonDotStyles = (FOUNDATIONS, FONT) => ({
    min_width: FOUNDATIONS.size_comp_resources_dot_size_small,
    height: FOUNDATIONS.size_comp_resources_dot_size_small,
});
//# sourceMappingURL=common.js.map